<h2 class="sectionTitle">Rebate Request - Request Details</h2>
<!-- [Rebate Request + Requester Decision (If Exists)] - Display Mode -->
<app-rebate-request-requestor-decision #rebateRequestRequestorDecision (rebateRequestRequestorDecisionLoadedFlag)="onRebateRequestRequestorDecisionLoadedFlag($event)"></app-rebate-request-requestor-decision>
<!-- Rebate Request - Display Mode -->
<app-rebate-request style="display: none;" #rebateRequest (rebateRequestLoadedFlag)="onRebateRequestLoadedFlag($event)"></app-rebate-request>
<div class="form-container">
    <div *ngIf="currentUser.IsAdmin && (rebateRequest.rebateRequestLoaded.CanPerformAcurateDataForm || rebateRequest.rebateRequestLoaded.CanPerformAdminActions)">
        <h4 class="section-title">Actions</h4>
        <!-- Admin Actions -->
        <div>

            <div ngbDropdown class="dropdown">
                <button  ngbDropdownToggle  class="btn btn-secondary" id="request-action-menu" type="button" aria-expanded="false">
                    Actions List<span class="caret"></span>
                </button>
                <ul  ngbDropdownMenu class="dropdown-menu" aria-labelledby="request-action-menu">
                    <li *ngIf="rebateRequest.rebateRequestLoaded.CanPerformAcurateDataForm">
                        <button type="button" class="" (click)="navigateToAccurateDataForm()">Accurate Data Form</button>
                    </li>
                    <ng-container *ngIf="rebateRequest.rebateRequestLoaded.CanPerformAdminActions">
                        <li>
                            <button type="button" class="" (click)="navigateToConfirmShipPassing()">Confirm Ship Passing</button>
                        </li>
                        <li>
                            <button type="button" class="" (click)="navigateToReleaseRebate()">Restudy / Cancel Rebate</button><!--Phase1 Galal Task19-->
                        </li>
                        <li>
                            <button type="button" class="" (click)="navigateToMarkRequestAsRefunded()">Mark Request as Refunded</button>
                        </li>
                    </ng-container>
                </ul>
            </div>
        </div>
    </div>
    <div *ngIf="!currentUser.IsAdmin && rebateRequest.rebateRequestLoaded.CanClone">
        <h4 class="section-title">Actions</h4>
        <!-- User Actions -->
        <div>
            <div ngbDropdown class="dropdown">
                <button ngbDropdownToggle id="request-action-menu" class="btn btn-primary dropdown-toggle" type="button"  aria-haspopup="true" aria-expanded="false">
                    Actions List<span class="caret"></span>
                </button>
                <ul ngbDropdownMenu class="dropdown-menu" aria-labelledby="request-action-menu">
                    <li>
                        <button type="button" class="" (click)="navigateToCloneRequest()">Clone Request</button>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
